import React from "react";
import { labels } from "../../../../../localization/labels";
import Table from "../../../../core/Table";

const SimilarKnowledge = ({ data, columns, contextMenuItems }) => {
  if (data?.length) {
    return (
      <Table
        data={data}
        columns={columns}
        showTableHeader
        tableLabel={labels.similarKnowledgeItems}
        contextMenuItems={contextMenuItems}
      />
    );
  } else {
    return null;
  }
};

export default SimilarKnowledge;
